// extracted by mini-css-extract-plugin
export default {"widget":"Arqwp"};